import { render, staticRenderFns } from "./V2TopPicks.vue?vue&type=template&id=456aecc5&scoped=true&"
import script from "./V2TopPicks.vue?vue&type=script&lang=js&"
export * from "./V2TopPicks.vue?vue&type=script&lang=js&"
import style0 from "./V2TopPicks.vue?vue&type=style&index=0&id=456aecc5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456aecc5",
  null
  
)

export default component.exports